<template>
  <div class="text-xs-center d-flex justify-center">
    <v-dialog v-model="dialog" width="50vh" overlay-color="white">
      <!-- button to open popUp to Add Link-->
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="purple darken-4 white--text text--darken-4"
          style="font-size: 10px; outline:none;"
          class="mt-2 mb-1"
          elevation="0"
          width="70%"
          @click="eventAnalytics"
        >{{$t("LoggedArea.Links.PopUp.MainPopUp.addLink")}}</v-btn>
      </template>

      <v-card color="white">
        <!-- PopUp Title -->
        <v-system-bar color="purple darken-4" height="30px">
          <v-icon
            color="white"
            size="25"
            v-if="component != 0"
            @click="decrementComponent"
          >mdi-arrow-left</v-icon>
          <v-spacer></v-spacer>
          <v-icon @click="dialog=false;component=0" color="white" size="25">mdi-close</v-icon>
        </v-system-bar>

        <Icons
          @component="component=$event"
          @set-src-icon="$emit('set-src-icon', $event)"
          v-if="component == 0"
          :icons="icons"
          :normalIcons="normalIcons"
        />

        <!-- calls MGM component-->
        <MGM v-else-if="component == 1" />

        <!-- calls Input component -->
        <Inputs
          class="my-auto"
          v-else
          @add-link="$emit('add-link', $event)"
          @close-pop-up="dialog=$event;component=0"
        />

        <v-divider style="margin-top:30px; margin-bottom: 0px;" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Icons from "./Icons";
import Inputs from "./Inputs";
import MGM from "./MGM";
import { analytics } from "@/config/firebaseConfig";
export default {
  components: { Icons, Inputs, MGM },
  data() {
    return {
      dialog: false,
      input: false,
      component: 0,
      clickIcon: "",
      srcIcon: "",
      normalIcons: [
        {
          name: this.$t("LoggedArea.Links.PopUp.MainPopUp.anyLink"),
          src: "./images/icons/link.svg",
          mgm: 0,
        },
      ],
      icons: [
        {
          name: "WhatsApp",
          src: "./images/icons/whatsApp.svg",
          mgm: 1,
        },
         {
          name: "Facebook",
          src: "./images/icons/facebook.svg",
           mgm: 1,
        },
        {
          name: "Instagram",
          src: "./images/icons/instagram.svg",
          mgm:1
        },
         {
          name: "LinkedIn",
          src: "./images/icons/linkedin.svg",
          mgm:1
        },
        {
          name: "GitHub",
          src: "./images/icons/github.svg",
          mgm:1
        },
         {
          name: "Medium",
          src: "./images/icons/medium.svg",
          mgm:1
        },
        {
          name: "Pinterest",
          src: "./images/icons/pinterest.svg",
          mgm:1
        },
        {
          name: "Slack",
          src: "./images/icons/slack.svg",
          mgm:1
        },
        {
          name: "Spotify",
          src: "./images/icons/spotify.svg",
          mgm:1
        },
        {
          name: "Stack Overflow",
          src: "./images/icons/stack-overflow.svg",
          mgm:1
        },
        {
          name: "Telegram",
          src: "./images/icons/telegram.svg",
          mgm:1
        },
        {
          name: "TikTok",
          src: "./images/icons/tiktok.svg",
          mgm:1
        },
        {
          name: "Twitch",
          src: "./images/icons/twitch.svg",
          mgm:1
        },
        {
          name: "Twitter",
          src: "./images/icons/twitter.svg",
          mgm:1
        },
        {
          name: "Youtube",
          src: "./images/icons/youtube.svg",
          mgm:1
        },
        {
          name: "Vimeo",
          src: "./images/icons/vimeo.svg",
          mgm:1
        },
      ],
    };
  },
  methods: {
    decrementComponent() {
      this.component = this.component > 0 && this.component < 3 ? 0 : 0;
    },
    eventAnalytics() {
      analytics.logEvent("Btn_Addlink");
    },
  },
};
</script>

<style>
</style>